export default __webpack_public_path__ + "static/media/burgerP.2acdd521.jpg";